import './Header.scss';
import React, { useState } from 'react';
import { Stack, Typography, Menu, MenuItem, IconButton, useMediaQuery, Divider } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/features/authSlice';
import appapi from '../../api/apiClient';
import { showmessage } from '../../utils/toastr';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import profileDefault from '../../assets/images/profileDefault.svg';
import profileDef from '../../assets/images/profileDef.svg';
import { setLoading, setIndex } from '../../redux/features/appSlice';
import { colors } from '../../utils/colors';
import { useNavigate } from 'react-router-dom';
import APPCONFIG from '../../config/apiConfig';
import { s3FilePathConverter } from '../../utils/s3FilePathConverter';
import { useTheme } from '@emotion/react';

import Logo from '../../assets/images/ze-logo.svg';

export default function Header() {
  const dispatch = useDispatch();
  const { userId, user } = useSelector((state) => state.auth);

  const theme = useTheme();

  const navigate = useNavigate();

  //profile menu
  const [anchorEl, setAnchorEl] = useState(false);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  //check whether mobile or not
  const isMobile = useMediaQuery('(max-width:1000px)');

  /**
   * @function Logout user
   */
  const handleLogout = async () => {
    dispatch(setLoading(true));
    handleMenuClose();

    const refresh_token = localStorage.getItem('refreshToken');
    let payload = {
      userId,
      refresh_token,
    };
    const response = await appapi.post(`/auth/logout`,{}, {params: payload});
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;

      if (data.status === '7400') {
        dispatch(logout());
      } else {
        dispatch(logout());
      }
    } else {
      dispatch(logout());
      dispatch(setLoading(false));
      // showmessage(`Something Went Wrong!`, 2000, 'error')
    }
  };

  const onOpenProfile = () => {
    navigate(`/settings/userProfile`);
    dispatch(setIndex(0));
    setAnchorEl(null);
  };

  return (
    <div
      className="headerContainer"
      style={{
        background: theme.palette.background.main,
        marginLeft: isMobile ? '56px' : '',
        height: '56px',
      }}
    >
      <Stack
        sx={{ height: '100%' }}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack
          direction="row"
          style={{ marginLeft: '16px' }}
        >
          {/* <Typography
            color={theme.palette.primary.light}
            className="fw-bold ff-Roboto"
            style={{ fontSize: '21px' }}
          >
            Carbon
          </Typography>
          <Typography
            color={theme.palette.secondary.main}
            className="fw-bold ff-Roboto"
            style={{ fontSize: '21px', marginLeft: '10px' }}
          >
            Wallet
          </Typography> */}
          <img src={Logo} />
        </Stack>
        {
          //120px
        }
        <div
          className="profileSection"
          style={{ minWidth: isMobile ? '100px' : '175px', backgroundColor: '#EFF3FF' }}
        >
          <Stack
            sx={{ height: '100%' }}
            direction="row"
            alignItems="center"
          >
            {/* <div className='brandContainer'>
                            <img src={lenscart} alt='brandLogo' />
                        </div> */}
            {/* <Divider style={{ border: '1px solid #496073', height: isMobile ? '32.5px' : '24px', margin: isMobile ? '3.25px 9px 3.25px 7px' : '8px 13px 8px 12px' }} orientation="vertical" flexItem /> */}
            <div
              className="profiledetail flex-aligncenter"
              style={{ flex: '1', width: 'calc(100% - 56px)' }}
            >
              <Stack
                direction="row"
                flex="1"
                justifyContent="space-between"
                style={{ width: '100%' }}
              >
                <div
                  className="flex-aligncenter"
                  style={{ width: 'calc(100% - 50px)' }}
                >
                  {
                    //style={{ marginLeft: '8px' }}
                  }
                  {/* <img
                    src={
                      user?.enterpriseLogo
                        ? s3FilePathConverter(user?.enterpriseLogo)
                        : profileDefault
                    }
                    alt="ProfileImage"
                    style={{ marginLeft: "8px" }}
                  />
                  <Divider
                    style={{
                      border: "1px solid #496073",
                      height: isMobile ? "32.5px" : "24px",
                      margin: isMobile
                        ? "3.25px 9px 3.25px 7px"
                        : "8px 12px 8px 12px",
                    }}
                    orientation="vertical"
                    flexItem
                  /> */}
                  <img
                    src={user?.profileImage ? s3FilePathConverter(user?.profileImage) : profileDef}
                    alt="ProfileImage"
                    style={{ marginRight: '5px', objectFit: 'cover' }}
                  />
                  {!isMobile && (
                    //max-width: '76px'
                    <Stack style={{ cursor: 'default', width: '79px' }}>
                      <Typography
                        className="ff-Roboto fs-12 fw-medium ellipseStyle"
                        style={{ color: theme.palette.userName.main, width: '99%' }}
                      >
                        {' '}
                        {user?.name || '-'}{' '}
                      </Typography>
                      {/* <Typography className='ff-Roboto fw-regular fs-12 ellipseStyle' style={{ color: colors.deactive, width: '99%' }}> {user?.emailId} </Typography> */}
                    </Stack>
                  )}
                </div>
                <IconButton
                  id="resource-button"
                  onClick={handleMenuOpen}
                  aria-controls={open ? 'resource-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  style={{ marginRight: '10px' }}
                >
                  <KeyboardArrowDownIcon className="svgColor" />
                </IconButton>
                <Menu
                  className="appbar"
                  id="resource-menu"
                  anchorEl={anchorEl}
                  open={open}
                  MenuListProps={{
                    'aria-labelledby': 'resource-button',
                  }}
                  onClose={handleMenuClose}
                  PopperProps={{
                    placement: 'bottom-end',
                  }}
                  PaperProps={{
                    style: {
                      width: '217px',
                      marginTop: '5px',
                    },
                  }}
                >
                  {/* <MenuItem
                    className="ff-Roboto fs-12 fs-medium"
                    style={{ color: colors.blackMain, minHeight: '32px' }}
                    onClose={handleMenuClose}
                    onClick={onOpenProfile}
                  >
                    {' '}
                    Change Password{' '}
                  </MenuItem> */}
                  <MenuItem
                    className="ff-Roboto fs-12 fs-medium"
                    style={{ color: colors.blackMain, minHeight: '32px' }}
                    onClose={handleMenuClose}
                    onClick={() => handleLogout()}
                  >
                    {' '}
                    Logout{' '}
                  </MenuItem>
                </Menu>
              </Stack>
            </div>
          </Stack>
        </div>
      </Stack>
    </div>
  );
}
